const getTimestamp = (value) => {
  if (!value) return 0;

  const timestamp = new Date(value).getTime();

  return Number.isFinite(timestamp) ? timestamp : 0;
};

export const organizeRentals = (rentals = []) => {
  const now = Date.now();

  const activeMap = new Map();
  const expiredMap = new Map();

  for (const rental of rentals) {
    if (!rental) continue;

    const video = rental.video || rental;

    if (!video?.videoTag) continue;

    const key = String(video.videoId ?? video.videoTag);

    const expiresAt = rental.expiresAt ?? rental.expires_at ?? null;
    const purchasedAt = rental.purchasedAt ?? rental.purchased_at ?? null;

    const paymentStatus = String(
      rental.paymentStatus ?? rental.payment_status ?? "",
    ).toLowerCase();

    const expiresTimestamp = getTimestamp(expiresAt);

    const isActive =
      paymentStatus === "paid" &&
      (rental.canWatch === true ||
        (rental.canWatch == null && expiresTimestamp > now));

    const item = {
      ...video,
      rentalId: rental.rentalId,
      purchasedAt,
      expiresAt,
      paymentStatus,
      rentalStatus: isActive ? "active" : "expired",
      canWatch: isActive,
    };

    if (isActive) {
      const existing = activeMap.get(key);

      if (!existing || expiresTimestamp > getTimestamp(existing.expiresAt)) {
        activeMap.set(key, item);
      }
    } else {
      const existing = expiredMap.get(key);

      if (
        !existing ||
        getTimestamp(purchasedAt) > getTimestamp(existing.purchasedAt)
      ) {
        expiredMap.set(key, item);
      }
    }
  }

  for (const key of activeMap.keys()) {
    expiredMap.delete(key);
  }

  return {
    activeVideos: [...activeMap.values()].sort(
      (a, b) => getTimestamp(b.expiresAt) - getTimestamp(a.expiresAt),
    ),

    expiredVideos: [...expiredMap.values()].sort(
      (a, b) => getTimestamp(b.purchasedAt) - getTimestamp(a.purchasedAt),
    ),
  };
};
